module.exports = __webpack_public_path__ + "img/logo.e325e017.png";